import { TFormSchema, useStore } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import axios from "axios";
import { api } from "@/comn";

export const eswiEnvs = {
    base: `${process.env.REACT_APP_BASE_PTL}`,
    comnSelectOrgList: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/comn/org/org-cd`, // Organization Code List

    comnSelectOrgInfoByTin: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/comn/org/org-info`, // Org Information
    comnAppPageList: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/cfgn/comn/app-list`, // Lpco Page List
    comnSelectComnCdList: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/comn/cd/`, // Common Code List

    comnSelectOrgAllList: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/comn/org/org-cd/all`, // Organization Code List
    comnSelectOrgLpco: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/comn/app/org-app`, // Applicaton List

    comnTreeOrgDept: `${process.env.REACT_APP_API_ESWO}/api/v1/eswo/cfgn/comn/org-dept`, // Department Tree Data
    frontComnCdMPpup: `${process.env.REACT_APP_BASE_ESW}/comn/ppup/comn-cd-m`, // Common Code Popup
    frontOrgDeptPpup: `${process.env.REACT_APP_BASE_ESW}/comn/ppup/org-dept`, // Organization Department Popup
    frontUsrPpup: `${process.env.REACT_APP_BASE_ESW}/comn/ppup/usr`, // User Popup
    comnSelectComnCdWithCondList: `${process.env.REACT_APP_API_ESWE}/api/v1/eswo/comn/cd/cond`, // Common Code List With Condition
    comnSelectComnInfo: `${process.env.REACT_APP_API_ESWE}/api/v1/eswo/comn/cd/info`, // Common Info
    comnSelectCpntList: `${process.env.REACT_APP_API_ESWE}/api/v1/eswe/comn/cpnt-list`, // Application Component List

    comnRprtLpco: `${process.env.REACT_APP_API_ESWE}/api/v1/eswe/comn/rprt/lpco`,
    comnRprtCo: `${process.env.REACT_APP_API_ESWE}/api/v1/eswe/comn/rprt/co`,

    ORG_CD_TRA: "OGAM0033",
};
/*
 * 프로젝트별 공통기능(함수) 사용시 작성
 */
export const eswiUtils = {
    /*
     * 샘플 함수
     */
    func: () => {
        console.log("call project common function");
    },

    /**
     * !==해당하는 폼에 값을 세팅한다.==!
     * Usage : eswiUtils.setFormValues(location.state, form.{formName})
     * @param state
     * @param form
     */
    setFormValues: (state: any, form: any) => {
        if (!comnUtils.isEmptyObject(state)) {
            Object.entries(state).map(([key, value]) => {
                console.log("key : %s , value: %s", key, value);
                form.setValue(key, value);
                // console.log(form.getValue());
            });
        } else {
            console.log("has no parameter datas.");
        }
    },

    setObjectValues: (fromObj: any, toObj: any) => {
        if (!comnUtils.isEmpty(fromObj)) {
            Object.keys(fromObj).forEach((item: any) => {
                // console.log("setObjectValues items ::: %s", item);
                if (toObj.hasOwnProperty(item)) {
                    toObj[item] = fromObj[item];
                }
            });
        }
    },
    getComnAppPageList: async (data: any, page: number, size: number) => {
        return await api.get(`${eswiEnvs.comnAppPageList}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getComnCdList: async (comnCd: string) => {
        try {
            const resp = await api.get(`${eswiEnvs.comnSelectComnCdList}/${comnCd}`);
            return resp.data.comnCdList.content;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getOrgCdList: async () => {
        try {
            const resp = await api.get(`${eswiEnvs.comnSelectOrgList}`);
            return resp.data.orgCdList?.content || [];
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getOrgCdAllList: async () => {
        try {
            const resp = await api.get(`${eswiEnvs.comnSelectOrgAllList}`);
            return resp.data.orgCdList?.content || [];
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getOrgLpcoList: async (orgCd: string) => {
        const resp = await api.get(`${eswiEnvs.comnSelectOrgLpco}/${orgCd}`);
        return resp.data.appList?.content || [];
    },
    getOrgLpcoByPrcsList: async (orgCd: string) => {
        const resp = await api.get(`${eswiEnvs.comnSelectOrgLpco}/${orgCd}/by-prcs`);
        return resp.data.appList?.content || [];
    },
    getOrgInfoByTin: async (orgTin: string) => {
        const resp = await api.get(`${eswiEnvs.comnSelectOrgInfoByTin}/${orgTin}`);
        return resp.data.info?.content || {};
    },
    setOrgInfoByTin: async (tin: any) => {
        const info = await eswiUtils.getOrgInfoByTin(tin);
        eswiUtils.orgInfo = { ...info };
        console.log(" eswiUtils.orgInfo ", eswiUtils.orgInfo);
        return info;
    },
    orgInfo: { orgCd: "", orgNm: "" },
    setSrchFormFromStore(srchForm: any, pgeStore: any) {
        srchForm?.setValues({ ...(pgeStore?.form || {}) });
    },
    getComnCdWithCondList: async (data: any) => {
        try {
            const resp = await api.get(`${eswiEnvs.comnSelectComnCdWithCondList}`, {
                params: comnUtils.toGetParams(data),
            });
            return resp.data.comnCdList.content;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },
    getComnCdInfo: async (data: any) => {
        const resp = await api.get(`${eswiEnvs.comnSelectComnInfo}`, {
            params: comnUtils.toGetParams(data),
        });
        return resp.data.comnCdIInfo?.content || {};
    },
    errorListSortByRow: (errList: any[]) => {
        const sortedList = errList
            .filter((item) => item.row !== undefined)
            .sort((a, b) => {
                return a.row! - b.row!;
            });
        const remainingItems = errList.filter((item) => item.row === undefined);
        return sortedList.concat(remainingItems);
    },
    getErrorObj: (row: any, label: string, message: string, input = "", type = "error") => {
        return {
            row: row,
            label: label,
            message: message,
            type: type,
            input: input,
        };
    },
    getErrorMessagesObj: (valdnItmNm: any, errMsgCn: string) => {
        return {
            valdnItmNm: valdnItmNm,
            msgCn: errMsgCn,
        };
    },

    // getCodeLabel: async (comnCd: string, value: string) => {
    //     const arrData: { key: string; value: any; created: Date; updated: Date } | undefined = await idb.get(
    //         "TANCIS",
    //         "RESOURCE",
    //         "comnCd:" + comnCd + ";" + comnUtils.getLocale(),
    //     );
    //     return arrData?.value.filter((item: any) => item.cdVldVal == value)?.[0]?.cdVldValNm;
    // },

    getOrgDeptTreeData: async (orgCd: string) => {
        const resp = await api.get(`${eswiEnvs.comnTreeOrgDept}/${orgCd}`);
        return resp.data.orgDeptTreeData?.content || [];
    },
    saveExcelDownload: (downurl: any, params: any) => {
        api.post(downurl, params, { responseType: "blob" })
            .then((response): void => {
                const blob: Blob = new Blob([response.data], { type: response.headers["content-type"] });
                const contentDisposition = response.headers["content-disposition"];
                let fileName: string = "exceldown.xlsx";
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.split(";").filter(function (str: any) {
                        return str.includes("filename");
                    });
                    if (fileNameMatch && fileNameMatch.length > 0) {
                        const arrFileNameMatch = fileNameMatch[0].split("=");
                        if (arrFileNameMatch != null && arrFileNameMatch.length > 1) {
                            fileName = arrFileNameMatch[1];
                        }
                    }
                }
                fileName = decodeURI(fileName).replaceAll('"', "");
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    // IE10 +
                    (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
                } else {
                    // not ie
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", fileName);
                    link.style.cssText = "display:none";
                    link.target = "_self";
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            })
            .catch((error) => {
                console.error("Error while downloading file:", error);
            });
    },
    // Search Application Componet !== 신청서 컴포넌트 목록 조회  ==!
    getCpntList: async (data: any) => {
        try {
            const resp = await api.get(`${eswiEnvs.comnSelectCpntList}`, {
                params: data,
            });
            return resp.data.cpntCdList.content;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },

    fileDownload: async (fileGrpUuid: any, fileUuid: any, fileNm: any, fileExt: any) => {
        const fileDownloadUrl = process.env.REACT_APP_API_PTLE || "/api/v1/ptle/comn/files/download";
        try {
            const response = await api.post(
                fileDownloadUrl,
                {
                    fileGrpUuid: fileGrpUuid,
                    fileUuid: fileUuid,
                },
                { responseType: "blob" },
            );
            const url = URL.createObjectURL(response.data);
            const a = document.createElement("a");
            const nm: string = fileNm || "";
            const ext: string = fileExt ? "." + fileExt : "";

            a.download = nm.endsWith(ext) ? nm : nm + ext;
            a.href = url;
            a.click();
            a.remove();
        } catch (error) {
            console.log(error);
        }
    },

    getBillPrint: (bllNo: any) => {
        const extClrUrl = process.env.REACT_APP_API_CLRE;
        http: return api.get(`${extClrUrl}/api/v1/coli/comn/comn-srvc/${bllNo}/printBll`, {
            responseType: "arraybuffer",
        });
    },
    // Get LPCO Report !== LPCO 보고서 미리보기 조회 ==!
    getRprtLpco: (appUuid: any, allStatYn: any = "") => {
        let url = `${eswiEnvs.comnRprtLpco}/${appUuid}`;
        if (allStatYn == "Y") {
            url = `${eswiEnvs.comnRprtLpco}/all/${appUuid}`;
        }
        return api.get(url, {
            responseType: "arraybuffer",
        });
    },
    // Get CO Registration Report !== 업체 등록 보고서 조회 ==!
    getRprtCo: (coUuid: any) => {
        return api.get(`${eswiEnvs.comnRprtCo}/${coUuid}`, {
            responseType: "arraybuffer",
        });
    },
};
